<template>
  <div>
    <div class="head_control">
      <div class="btn_box" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="head_title">每日下载稿件</div>
    </div>
    <div class="content">
      <div class="imgbox">
        <img class="fileimg" src="../../assets/image/fileimg.png" alt="" />
      </div>
      <el-button
        @click="downloadFile"
        size="small"
        class="record_btn record_btn1"
        round
      >
        下载文件
      </el-button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {
  connectionrecord_day_zip,
  connectionrecord_week_zip
} from "@/utils/owner";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      type: "",
      pathURL: "",
      information: {}
    };
  },
  created() {
    // 接受传递的参数
    if (this.$route.query) {
      this.information = JSON.parse(this.$route.query.information);
      this.pathURL = this.$route.query.pathURL;
      this.type = this.$route.query.sataus;
      console.log(this.information, 111);
    }
    console.log("this.pathURL", this.pathURL);
  },
  methods: {
    goBack() {
      this.$router.push({ path: this.pathURL });
    },
    downloadFile() {
      var that = this;
      let obj = that.information.obj;
      console.log("当前路径", this.pathURL);
      // 日结登记表
      if (this.pathURL == "OwnerDayRecordMobile") {
        connectionrecord_day_zip(obj).then(res => {
          if (res.data.code == 1) {
            let file_name = res.data.data.title;
            let url = res.data.data.xurl;

            var suffix = url.substring(url.lastIndexOf(".")); //zip
            if (suffix == "zip") {
              var link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", file_name);
              console.log("***", link);
              document.body.appendChild(link);
              link.click();
            } else {
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", file_name);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            }
            that.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
      // 周结登记表
      if (this.pathURL == "OwnerWeekRecordMobile") {
        connectionrecord_week_zip(obj).then(res => {
          if (res.data.code == 1) {
            let file_name = res.data.data.title;
            let url = res.data.data.xurl;

            var suffix = url.substring(url.lastIndexOf(".")); //zip
            if (suffix == "zip") {
              var link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", file_name);
              document.body.appendChild(link);
              link.click();
            } else {
              // this.download(url, file_name);
              // const xhr = new XMLHttpRequest();
              // xhr.open("GET", url, true); // url 文件的完整地址 http:XXX
              // xhr.responseType = "blob";
              // xhr.onload = function() {
              //   if (xhr.status === 200) {
              //     const res = xhr.response;

              const link = document.createElement("a");
              link.style.display = "none";
              // const url = window.URL.createObjectURL(res);
              link.href = url;
              link.setAttribute("download", file_name);
              document.body.appendChild(link);
              console.log(link);

              link.click();
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);

              //   }
              // };
              // xhr.send();
            }
            that.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.head_control {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  margin-left: 15px;
}
.head_title {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  margin-left: 30%;
}
.btn_box i {
  font-size: 25px;
}
.content {
  display: flex;
  flex-direction: column;
  height: 50vh;
  justify-content: space-between;
  margin-top: 25vh;
}
.imgbox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fileimg {
  width: 65%;
}
.record_btn1 {
  width: 327px;
  height: 40px;
  background: #157df8;
  border-radius: 20px;
  color: #fff;
  font-size: 18px;
  margin: 0 auto;
  padding: 3px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/owner/downloadFile.vue